import {stickedLeft, StickyBorderRight, TableCell, tableColWidths} from "./styling/participation";

// renderuje lewa czesc tabeli nazwa/tel/email
const LeftPartBodyTable = ({rowStyle, lp, entry, getStickyLeft, visibleColumns, handleCopyEmail}) => {
    const rowStyleObj = rowStyle(lp, entry.musician_category)

    return (<>
        <th scope="row" style={{ ...stickedLeft, left: '0', backgroundColor: rowStyleObj.backgroundColor, verticalAlign: 'middle'}}>{lp + 1}</th>
        <td style={{ ...stickedLeft, left: tableColWidths.index, backgroundColor: rowStyleObj.backgroundColor, verticalAlign: 'middle'}}>{entry.username}</td>
        <TableCell style={{
            ...stickedLeft, left: getStickyLeft(['index', 'name']), backgroundColor: rowStyleObj.backgroundColor, verticalAlign: 'middle'}}
                   isHidden={!visibleColumns.telephone}>
            {visibleColumns.telephone ? entry.telephone || "-" : "-"}
        </TableCell>

        <StickyBorderRight
            isHidden={!visibleColumns.mail}
            onClick={() => handleCopyEmail(entry.mail)}
            style={{
                ...stickedLeft,
                left: getStickyLeft(['index', 'name', 'telephone']),
                cursor: visibleColumns.mail && entry.mail ? "pointer" : "default",
                backgroundColor: rowStyleObj.backgroundColor,
                verticalAlign: 'middle'
            }}
        >
            {visibleColumns.mail ? entry.mail || "-" : "-"}
        </StickyBorderRight>
    </>)
}

export default LeftPartBodyTable;

